import React, { useState, useCallback } from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import ModalHeader from "components/global/modal-header";
import Input from "components/input/input";
import { isValidYoutubeVideoLink } from "utils/utils";
import LoadingIndicator from "assets/svg/loading-indicator";
import _ from "lodash";
import update from "immutability-helper";
import { useDropzone } from "react-dropzone";
// import { FaPlus, FaMinus } from "react-icons/fa";
import validator from "validator";
import CustomCheckbox from "components/checkbox/custom-checkbox";
import { useDialogHook } from "utils/customhooks";
import UploadSizeModal from "components/file-upload/upload-size-modal";
import AddPhotoDropZone from "assets/svg/add-photo-dropzone-svg";  
import { KB, MB, maxUploadSize } from "utils/constant";
import { Close } from "assets/svg/sidebar/icons";
import { useTranslation } from "react-i18next";
import Select from "components/select/select";

let ORIENTATION = [
  {
    id: 1,
    label: "Landscape",
    value: "Landscape",
  },
  {
    id: 2,
    label: "Portrait",
    value: "Portrait",
  },
  {
    id: 3,
    label: "Square",
    value: "Square",
  },
];
export default function AddVideoModal({ hide, userData, profile, ...props }) {
  const { http } = global.services;

  const [links, setLinks] = useState([""]);
  const [thumbnail, setThumbnail] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);

  const [errorMessages, setErrorMessages] = useState({});
  const [adultContent, setAdultContent] = useState(false);
  const [showReels, setShowReels] = useState(false);
  const [frontPageShowreel, setFrontPageShowreel] = useState(false);
  const [photo, setPhoto] = useState(null); 
  const [orient, setOrient] = useState(ORIENTATION[0]);
  const uploadSizeModal = useDialogHook(UploadSizeModal);
  const {t} = useTranslation()
  React.useEffect(() => {
    if (photo) {
      setPhotoPreview();
    }
  }, [photo]);

  const [preview, setPreview] = useState({
    name: "",
    size: 0,
    path: ""
  });

  const submit = async () => {
    let errors = {};
    setErrorMessages(errors);

    try {
      setSubmitLoading(true); 
      let dataPayload = {
        // user_profile_id: profile.id,
        // type: "video",
        links: [],
        // is_adult_content: adultContent,
      };

      (links || []).forEach((link, index) => {
        if (link) {
          if (validator.isURL(link)) {
            dataPayload.links.push(link);
          } else {
            errors = {
              ...errors,
              [`link.${index}`]: "Invalid Link",
            };
          }
        } else {
          errors = {
            ...errors,
            [`link.${index}`]: "This field is required.",
          };
        }
      });

      if (!_.isEmpty(errors)) {
        return setErrorMessages((prev) => ({ ...prev, ...errors }));
      }

      let payload = new FormData();
      payload.append(`user_profile_id`, profile.id);
      payload.append("type", "video");
      payload.append("links", dataPayload.links); 
      payload.append("is_adult_content", adultContent);
      payload.append("is_showreels", showReels);
      payload.append("is_front_page_showreel", frontPageShowreel);
      payload.append(`thumbnail`, photo ? photo[0] : null);
      payload.append("orientation", orient?.value || "Landscape")

      const { data } = await http.post("public/user-galleries", payload);
      if (data) {
        hide(true);
      }
    } catch (err) {
      if (err.status === 422){
        errors = {
          ...errors,
          ...err.data?.errors,
        };
        console.log(errors)
        return setErrorMessages((prev) => ({
          ...prev,
          ...errors
        }));
      }
        
        
      console.log(err);
      setSubmitLoading(false);
    } finally {
      setSubmitLoading(false);
    }
  };

  // const onAdd = () => {
  //   const copyLinks = _.clone(links);
  //   copyLinks.push("");
  //   setLinks(copyLinks);
  // };

  // const onRemove = (index) => {
  //   let copyLinks = _.clone(links);
  //   let result = update(copyLinks, { $splice: [[index, 1]] });
  //   if (result.length === 0) {
  //     result.push("");
  //   }
  //   setLinks(result);
  // };

  const onBlur = (index) => {
    let copyLinks = _.clone(links);
    let value = copyLinks[index];

    if (value && !value.includes("http://") && !value.includes("https://")) {
      value = `https://${value}`;
    }

    let result = update(copyLinks, {
      [index]: { $set: value },
    }); //remove

    setLinks(result);
  };

  const onDrop = useCallback(acceptedFiles => {
    if (acceptedFiles[0].size > maxUploadSize) {
      showUploadSizeModalError();
    } else {
      setPhoto(acceptedFiles);
    }
  }, []);

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    noClickL: true,
    accept: {
      'image/*': [],
    }
  });

  const showUploadSizeModalError = () => {
    uploadSizeModal({}, (callback) => {
      console.log('callback', callback)
    })
  }
  

  const handleInputChange = async (event, index) => {
    const copyLinks = _.clone(links);
    copyLinks[index] = event.target.value;
    setLinks(copyLinks);
    const thumbnailUrl = await getVideoThumbnail(event.target.value);
    const thumbnailFile = await urlToFile(thumbnailUrl);
    setPhoto([thumbnailFile]);
  };

  const urlToFile = async (thumbnailUrl) => {
    const response = await http.get(`/fetch-thumbnail?url=${encodeURIComponent(thumbnailUrl)}`, {}, {
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'image/jpeg'
        }
    });
    // Convert the response to a Blob
    const blob = new Blob([response.data], { type: response.headers['content-type'] || 'image/jpeg' });

    const file = new File([blob], "thumbnail.jpg", { type: "image/jpeg" });

    return file;
};

  const removeUploadedPhoto = () => {
    setPhoto(null);
    setPreview(null);
  }

  const setPhotoPreview = () => {
    console.log(photo[0])
    if (typeof photo === 'string') {
        setPreview({
            name: 'Thumbnail',
            size: 'N/A',
            path: photo
        });
    } else {
        let size = photo[0].size;

        if (size > MB) {
            size /= MB;
            size = `${Math.round(size * 10) / 10}MB`;
        } else if (size > KB) {
            size /= KB;
            size = `${Math.round(size * 10) / 10}KB`;
        } else {
            size = `${size}B`;
        }

        setPreview({
            name: photo[0].name,
            size: size,
            path: URL.createObjectURL(photo[0])
        });
    }
};

  const Footer = () => {
    return (
      <>
        <div className="w-full flex items-center justify-start 1sm:justify-end space-x-2">
          <Button
            buttonName="Cancel"
            buttonClass="bg-thBg py-4 px-8 hover:bg-gray"
            buttonTextClass="text-black text-sm font-semibold"
            onClick={() => hide()}
            disabled={submitLoading}
          />
          <Button
            key="save-btn-category"
            buttonName="Save Links"
            buttonClass="bg-primary py-4 px-8 hover:bg-darkPrimary"
            buttonTextClass="text-white text-sm font-semibold flex items-center"
            onClick={submit}
            disabled={submitLoading}
            loadingIcon={
              submitLoading ? (
                <LoadingIndicator className="text-white w-4 h-4 ml-2" />
              ) : null
            }
          />
        </div>
      </>
    );
  };

  async function getVideoThumbnail(videoUrl) {
    let thumbnailUrl = '';

    if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
        const videoId = videoUrl.split('v=')[1] || videoUrl.split('/').pop();
        const ampersandPosition = videoId.indexOf('&');
        thumbnailUrl = `https://img.youtube.com/vi/${ampersandPosition !== -1 ? videoId.substring(0, ampersandPosition) : videoId}/0.jpg`;
    } else if (videoUrl.includes('vimeo.com')) {
        const videoId = videoUrl.split('/').pop();
        thumbnailUrl = `https://vumbnail.com/${videoId}.jpg`;
    } else if (videoUrl.includes('dailymotion.com')) {
        const videoId = videoUrl.split('/').pop();
        thumbnailUrl = `https://www.dailymotion.com/thumbnail/video/${videoId}`;
    } else if (videoUrl.includes('odysee.com')) {
      let extractedThumbnail;
      try {
        extractedThumbnail = await http.get(`/extract-thumbnail?url=${encodeURIComponent(videoUrl)}`, {});
      
        // Use a regular expression to extract the URL after "plain/"
        const match = extractedThumbnail.data.image.match(/plain\/(https:\/\/.+)$/);
        
        if (match && match[1]) {
          thumbnailUrl = match[1];
        }
        else thumbnailUrl = 'https://via.placeholder.com/150';
      } catch (error) {
        console.error("Error extracting thumbnail:", error);
        thumbnailUrl = 'https://via.placeholder.com/150';
      }
    } else if(videoUrl.includes('tiktok.com')) {
      const oembedData = await http.get(`https://www.tiktok.com/oembed?url=${videoUrl}`, {});
      if(oembedData.data.thumbnail_url) {
        thumbnailUrl = oembedData.data.thumbnail_url;
      }else thumbnailUrl = 'https://via.placeholder.com/150';
    }
    else {
      let extractedThumbnail;
      try {
        extractedThumbnail = await http.get(`/extract-thumbnail?url=${encodeURIComponent(videoUrl)}`, {});
      } catch (error) {
        console.error("Error extracting thumbnail:", error);
        extractedThumbnail = { data: { image: '' } };
      }
      thumbnailUrl = extractedThumbnail.data.image;
      if(!thumbnailUrl) thumbnailUrl = 'https://via.placeholder.com/150';
    }

    setThumbnail(thumbnailUrl);

    return thumbnailUrl;
}

  const toggleAdultContentCheckbox = (e) => {
    setAdultContent(!e.target.checked);
  }

  const toggleShowreelsCheckbox = (e) => {
    setShowReels(e.target.checked);
  }

  const toggleFrontPageShowreelCheckbox = (e) => {
    setFrontPageShowreel(e.target.checked);
  }

  const facebookOrient = async (e) => {
      console.log(e)
      setOrient(e)
    }

  const IsFacebookOrTwitter = ({ value, obj }) => {
        if (
          value.includes("www.facebook.com") ||
          value.includes("twitter.com") ||
          value.includes("x.com")
        ) {
          return (
            <Select
              // label="Orientation"
              options={ORIENTATION}
              placeholder="Orientation"
              name="orientation"
              value={orient}
              height={58}
              formContainer="w-full flex-1 flex-shrink-0"
              onChange={(e) => facebookOrient(e)}
              // errorMessage={errorMessages?.privacy}
              labelClass="text-sm font-bold text-darkerGray leading-4 marked"
            />
          );
        }
      return <></>;
    };

  return (
    <Modal
      footer={<Footer />}
      width="w-full md:w-15/20 2md:w-11/20 lg:w-9/20 xl:w-6/20"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible"
      footerClass="border-t border-gray">
      <div className="w-full">
        {/* header */}
        <ModalHeader title={t('addFile', {file:t('videos')})} hide={hide} />
        {/* content */}
        <div className="px-8.5 py-6">
          {/* profile */}
          {links.map((link, index) => (
            <div key={index} className="flex flex-column">
              <Input
                inputContainerClass="form-input-container mb-2"
                value={link}
                name={`input-link-${index}`}
                placeholder="e.g. https://example.com/video"
                outsideLabelClass="text-sm font-bold text-darkerGray"
                noLabelPaddingY="1rem"
                type="text"
                onChange={(e) => handleInputChange(e, index)}
                onBlur={() => onBlur(index)}
                errorMessage={errorMessages[`link.${index}`] || errorMessages?.video?.link}
                errorMessagePosition="bottom"
              />
               <IsFacebookOrTwitter
                  value={link}
                  index={index}
                />

          <div className="mt-3">
            {/* <div>{thumbnail}</div> */}
            <h1>{t('addAThumbnail')}</h1>
                {/* dropzone */}
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <div className="add-photo-dropzone">
                <AddPhotoDropZone />
              </div>
            </div>
              {
                photo && <div className="flex mt-4 items-center justify-center">
                  <div className="flex items-center p-2 space-x-4 h-[120px] rounded-md shadow-md w-full justify-between border-slate-200">
                    <div className="flex items-center p-2 space-x-4 text-ellipsis overflow-hidden">
                      <img className="w-[100px] h-[100px] rounded-md" src={preview.path} width={60} height={60} />
                      <div className="flex flex-column ">
                        <span className="">{preview.name}</span>
                        <span className="">{preview.size}</span>
                      </div>
                    </div>
                    
                    <div className="cursor-pointer" onClick={removeUploadedPhoto}>
                      <Close className="w-4 h-4" fill={"#333333"} />
                    </div>
                  </div>
                </div>
              }
                <div className="mt-2">
                  <CustomCheckbox
                    label={
                      <p className="checkbox-text">
                        {t('thisFileDoesNotContainAdult', {file:t('video')})}
                      </p>
                    }
                    name={"thisFileDoesNotContainAdult"}
                    checked={!adultContent}
                    onChange={(e) => toggleAdultContentCheckbox(e)}
                    v2={true}
                  />
                </div>
                <div className="mt-2">
                  <CustomCheckbox
                    label={
                      <p className="checkbox-text">
                        {t('makeThisAsYourVideoShowreel')}
                      </p>
                    }
                    name={"makeThisAsYourVideoShowreel"}
                    checked={showReels}
                    onChange={(e) => toggleShowreelsCheckbox(e)}
                    v2={true}
                  />
                </div>
                <div className="mt-2">
                  <CustomCheckbox
                    label={
                      <p className="checkbox-text">
                        {t('makeThisVideoShowreelInFrontPage')}
                      </p>
                    }
                    name={"makeThisVideoShowreelInFrontPage"}
                    checked={frontPageShowreel}
                    onChange={(e) => toggleFrontPageShowreelCheckbox(e)}
                    v2={true}
                  />
                </div>
              </div>

              {/* <button
                className="h-6.5 w-6.5 bg-lightBlack rounded-full"
                onClick={() => onRemove(index)}>
                <FaMinus className="m-auto text-white" />
              </button> */}
            </div>
          ))}

          {/* <Button
            buttonName="Add Another Link"
            buttonTextClass="text-sm text-white font-semibold flex items-center"
            iconPosition="left"
            icon={<FaPlus className="mr-3" />}
            buttonRadius="6px"
            buttonClass="relative py-4 px-9 bg-lightBlack"
            onClick={onAdd}
          /> */}
        </div>
        {/* end content */}
      </div>
    </Modal>
  );
}
